import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  errorMessage:any=[];
  constructor(public modalService: NgbActiveModal,private common:CommonService) {this.common.isSystemAlert=true;}
  ngOnInit(): void {
    this.errorMessage=commonErrorMessage;
  }
}
